<!--
 * @Description: 学生 详情 班级信息
 * @Author: PF
 * @Date: 2023-11-30 10:44:43
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:37:33
-->

<template>
  <div class="hp100" v-if="sffb" v-loading="loading">
    <el-empty v-if="loading" class="hp100" description="暂无信息" />
    <table v-else width="100%" border="0" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
          <td><div align="right"><strong>行政班代码：</strong></div></td>
          <td>{{ruleForm.xzbdm}}</td>
          <td><div align="right"><strong>行政班名称：</strong></div></td>
          <td>{{ruleForm.xzbmc}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>建班年月：</strong></div></td>
          <td>{{ruleForm.jbny}}</td>
          <td><div align="right"><strong>教室：</strong></div></td>
          <td>{{ruleForm.jsmc}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>班主任：</strong></div></td>
          <td>{{ruleForm.bzrxm}}</td>
          <td><div align="right"><strong>班长：</strong></div></td>
          <td>{{ruleForm.bzxm}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>班级状态：</strong></div></td>
          <td><span v-if="ruleForm.bjzt === 1">在校</span><span v-if="ruleForm.bjzt === 7">毕业</span></td>
          <td><div align="right"><strong>总人数：</strong></div></td>
          <td>{{ruleForm.zrs}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>男生人数：</strong></div></td>
          <td>{{ruleForm.nansrs}}</td>
          <td><div align="right"><strong>女生人数：</strong></div></td>
          <td>{{ruleForm.nvsrs}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>年级：</strong></div></td>
          <td>{{ruleForm.njmc}}</td>
          <td><div align="right"><strong>校区：</strong></div></td>
          <td>{{ruleForm.xqmc}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>系部：</strong></div></td>
          <td>{{ruleForm.xbmc}}</td>
          <td><div align="right"><strong>机构：</strong></div></td>
          <td>{{ruleForm.jgmc}}</td>
        </tr>
        <tr>
          <td><div align="right"><strong>专业：</strong></div></td>
          <td>{{ruleForm.zymc}}</td>
          <td><div align="right"><strong>教学计划实施方案：</strong></div></td>
          <td>{{ruleForm.jxjhssfamc}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <el-empty v-else class="hp100" description="尚未分班" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadData } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const loading = ref(false)
const sffb = ref(false)
watch(
  () => props.row,
  () => {
    if (props.row) {
      sffb.value = false
      if (props.row.bjid) {
        loading.value = true
        sffb.value = true
        loadData({
          url: '/api/v2/pdp/banji/' + props.row.bjid,
          ruleForm,
          loadSuccess: function (res) {
            loading.value = false
          }
        })
      }
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
td {
  height: 40px;
}
</style>
